<template>
  <div id="activity" ref="homePage">
    <!-- 活动页面 -->
    <div class="content">
      <div class="nav" id="str" v-if="isStr">
        活动未开始&nbsp; &nbsp;   活动开始时间9:00
      </div>
      <div class="nav" id="end" v-if="isEnd">
        本次活动已结束
      </div>
      <div class="nav" v-if="showActive">
        <div>本场活动时间：{{activeTime}}</div>
        <div>全天剩余名额：{{quota}}</div>
      </div>
      <div class="nav" v-else>
        <div>本场活动已结束，下场活动时间：{{activeTime}}</div>
      </div>
      <div class="imgBox">
        <img src="../assets/img/5.27-2.png" alt />
         <a href="http://kefu.easemob.com/webim/im.html?configId=ad698710-d45c-4843-99ba-fb2255126b4e" class="kefu" >
        <img src="@/assets/img/领取.gif" alt />
      </a>
      <a href="http://mall.jingmaie-co.cn/#/goodsDetail/97" class="buynow">
        <!-- <img src="@/assets/img/zhifu.png" alt=""> -->
        <img src="@/assets/img/透明去购买.png" alt="">
      </a>
      </div>
      <!-- 底部 -->
      <div class="footer">
        <p>京迈（湖北）电子商务股份有限公司</p>
        <p>联系电话：400-1383633</p>
        <p>地址：武汉东湖新技术开发区高新二路388号</p>
        <p>武汉光谷国际生物医药企业加速器3.1期16栋1层01厂房号</p>
        <p style="margin-bottom:0">京迈（湖北）电子商务股份有限公司，涵盖美妆护肤、膳食营养及个人清护，致力为您打造轻妆简食的健康、品质新生活。</p>
      </div>
    </div>
  </div>
</template>
<script>
import {activity} from '@/api'
export default {
  data() {
    return {
      showActive: true,
      isStr:false,
      isEnd:false,
      timeList: [9, 10, 11, 12, 13, 14, 15, 16, 20, 21], //时间数组
      activeTime: "9:00-10:00", //  本场活动时间
      quota: " ", // 剩余名额
      gettime: " ", //当前时间
    };
  },

  created() {
    this.getNum()
    // 开启页面获取一次时间
    this.getTime();
  },
  mounted() {
    // 每五秒钟刷新一次时间
    this.currentTime();
  },
  methods: {
    // 获取当前时间
    getTime() {
      var _this = this;
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.gettime = hh + ":" + mf + ":" + ss;

      if (hh < this.timeList[0]) {
        this.isStr = true
      } else if (hh >= this.timeList[0] && hh < this.timeList[1]) {
        this.showActive = true;
        this.activeTime = this.timeList[0] + ":00-" + this.timeList[1] + ":00";
      } else if (hh >= this.timeList[1] && hh < this.timeList[2]) {
        this.showActive = false;
        this.activeTime = this.timeList[2] + ":00-" + this.timeList[3] + ":00";
      } else if (hh >= this.timeList[2] && hh < this.timeList[3]) {
        this.showActive = true;
        this.activeTime = this.timeList[2] + ":00-" + this.timeList[3] + ":00";
      } else if (hh >= this.timeList[3] && hh < this.timeList[4]) {
        this.showActive = false;
        this.activeTime = this.timeList[4] + ":00-" + this.timeList[5] + ":00";
      } else if (hh >= this.timeList[4] && hh < this.timeList[5]) {
        this.showActive = true;
        this.activeTime = this.timeList[4] + ":00-" + this.timeList[5] + ":00";
      } else if (hh >= this.timeList[5] && hh < this.timeList[6]) {
        this.showActive = false;
        this.activeTime = this.timeList[6] + ":00-" + this.timeList[7] + ":00";
      } else if (hh >= this.timeList[6] && hh < this.timeList[7]) {
        this.showActive = true;
        this.activeTime = this.timeList[6] + ":00-" + this.timeList[7] + ":00";
      } else if (hh >= this.timeList[7] && hh < this.timeList[8]) {
        this.showActive = false;
        this.activeTime = this.timeList[8] + ":00-" + this.timeList[9] + ":00";
      } else if (hh >= this.timeList[8] && hh < this.timeList[9]) {
        this.showActive = true;
        this.activeTime = this.timeList[8] + ":00-" + this.timeList[9] + ":00";
      } else if (hh >= this.timeList[9]) {
        this.isEnd = true;
      }
    },
    currentTime() {
      setInterval(this.getTime, 5000);
    },
    // 库存剩余量
    async getNum(){
      let res = await activity()
      if(res.status===1){
        this.quota = res.data.surplusGoodsNum
      }else{
        this.$toast({message:res.msg,duration:'2000'}) 
      }
    }
  }
};
</script>
<style lang="less" scoped>
#activity {
  width: 750px;
  position: relative;
  .content {
    position: relative;
    #str{
      z-index: 999;
    }
    #end{
      z-index: 999;
    }
    .nav {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 80px;
      line-height: 60px;
      background-color: #ffeb3b;
      color: #d43030;
      font-size: 30px;
      font-weight: 700;
      padding: 10px 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
    }
    .imgBox {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      .kefu {
        position: absolute;
        top: 40%;
        left: 17%;
        z-index: 99;
        z-index: 999999;
        width: 66%;
        height: 14%;
        img {
          width: 100%;
          height: 100%;
        }
      }
     
.buynow{
        position: absolute;
        bottom: 13%;
        left: 45%;
        z-index: 999999;
        width: 10%;
        height: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
   
    
    .footer {
      text-align: center;
      padding: 0 30px 50px;
      p {
        margin: 6px;
      }
    }
  }
}
</style>